export default {
  linkList: [
    [
      {
        title: "Trading Products",
        list: [
          {
            label: "Forex",
            link: "/tradingproduct?index=0",
          },
          {
            label: "Commodities",
            link: "/tradingproduct?index=1",
          },
          {
            label: "Indices",
            link: "/tradingproduct?index=2",
          },
          {
            label: "Stocks",
            link: "/tradingproduct?index=3",
          },
          {
            label: "ETFs",
            link: "/tradingproduct?index=4",
          },
        ],
      },
      {
        title: "Trading Tools",
        list: [
          {
            label: "MT4 Download",
            link: "/MT4",
          },
          {
            label: "MT5 Download",
            link: "/MT5",
          },
          {
            label: "EA Trading and Indicators  ",
            link: "/tools",
          },
          {
            label: "PAMM",
            link: "/PAMM",
          },
          {
            label: "Market Analysis",
            link: "/market-analysis",
          },
        ],
      },
    ],
    [
      {
        title: "Accounts & Conditions",
        list: [
          {
            label: "Trading Accounts",
            link: "/TradingAccount",
          },
          {
            label: "Leverage & Margin",
            link: "/leverage-margin",
          },
          {
            label: "Deposits & Withdrawals",
            link: "/funding",
          },
          {
            label: "Dividends",
            link: "/dividend",
          },
          {
            label: "Institutional Services",
            link: "/service",
          },
          {
            label: "Liquidity Solutions",
            link: "/technology",
          },
        ],
      },
    ],
    
    [
      {
        title: "About EBC",
        list: [
          {
            label: "WHY EBC",
            link: "/about-us",
          },
          {
            label: "Legal Documents",
            link: "/LegalDocumen",
          },
          {
            label: "Sustainability & Impact",
            link: "/ESG",
          },
          {
            label: "EBC News",
            link: "/LearningCenter?tabId=0",
          },
          {
            label: "FAQ",
            link: "https://support.ebchelp.com/hc/en-001",
          },
          {
            label: "Official Channel Verification",
            link: "/official-verification",
          },
        ],
      },
      {
        title: "Partners",
        list: [
          {
            label: "FC Barcelona ",
            link: "/FCB",
          },
          {
            label: "University of Oxford",
            link: "/partners/oxford",
          },
          {
            label: "Affiliate Programmes",
            link: "/affiliate-programmes",
          },
        ],
      },
    ],
    [
        {
          title: "EBC Activities",
          list: [
            {
              label: "EBC‘s Million Dollar Trading Challenge",
              link: "/million-dollar-challenge-2",
            },
            {
              label: "Creator Incentive Programme",
              link: "/activityList/creator-incentives",
            },
            {
              label: "Enjoy Monthly Payouts",
              link: "/pay",
            },
            
            {
              label: "More Activities",
              link: "/activity",
            },
          ],
        },
    ],
  ],
  context: `
    <p>
        <span class="page-footer-intro-blod">
          EBC Financial Group is a co-brand shared by a group of entities
          including:<br />
        </span>

        EBC Financial Group (SVG) LLC is authorized by the St.Vincent and the
        Grenadines Financial Services Authority(SVGFSA),and the company
        registration number is 353 LLC 2020, with registered address at Euro
        House, Richmond Hill Road, Kingstown, VC0100, St. Vincent and the
        Grenadines.
      </p>
      <p>
        <span class="page-footer-intro-blod"
          >Other Relevant Entities<br
        /></span>
        EBC Financial Group (UK) Limited is authorised and regulated by the
        Financial Conduct Authority. Reference Number: 927552. Website:<a
          target="_blank"
          href="https://www.ebcfin.co.uk"
          rel="nofollow"
          >www.ebcfin.co.uk</a
        >
        <br />
        EBC Financial Group (Cayman) Limited is licensed and regulated by the
        Cayman Islands Monetary Authority (Number: 2038223). Website:
        <a target="_blank" href="https://www.ebcgroup.ky" rel="nofollow">
          www.ebcgroup.ky</a
        >
        <br />
        EBC Financial (MU) Limited is licensed and regulated by the the
        Financial Services Commission, Mauritius (License Number GB24203273)
        with registrated address at 3rd Floor, Standard Chartered Tower,
        Cybercity, Ebene, 72201, Republic of Mauritius. Website for this entity
        is maintained separately.
        <br />
        EBC Financial Group (Comoros) Limited is authorised by The Autonomous
        Island of Anjouan, Union of Comoros Offshore Finance Authority with
        License number L 15637/EFGC, with registered office address at Hamchako,
        Mutsamudu, Autonomous Island of Anjouan, Union of Comoros.
        <br />
        EBC Financial Group (Australia) Pty Ltd (ACN: 619 073 237) is authorised
        and regulated by the Australian Securities and Investments Commission
        (Number: 500991). EBC Financial Group (Australia) Pty Ltd is a related
        entity of EBC Financial Group (SVG) LLC. The two entities are managed
        separately. The financial products and services offered on this website
        are NOT provided by the Australian entity and no recourse against the
        Australian entity is available.
        <br />
        EBC Group (Cyprus) Ltd, faciliates payment services to the licensed and
        regulated entities within the EBC Financial Group strucutre, registered
        under the Companies Law of Republic of Cyprus with the number HE 449205,
        registered office address at 101 Gladstonos, Agathangelou Business
        Centre, 3032 Limassol, Cyprus.
      </p>
      <p>
        <span class="page-footer-intro-blod"> Business Address: </span>
        The Leadenhall Building, 122 Leadenhall Street, London, United Kingdom,
        EC3V 4AB. Email Address :cs@ebc.com . Telephone : +44 20 3376 9662
      </p>
      
      <p>
        <span class="page-footer-intro-blod">Regional Restrictions:</span>
        EBC does not offer any services to citizens and residents of certain
        jurisdictions including: Afghanistan, Belarus, Burma (Myanmar), Canada,
        Central African Republic, Congo, Cuba, Democratic Republic of the Congo,
        Eritrea, Haiti, Iran, Iraq, Lebanon, Libya, Malaysia, Mali, North Korea
        (Democratic People's Republic of Korea), Russia, Somalia, Sudan, South
        Sudan, Syria, Ukraine (including Crimea, Donetsk, and Luhansk Regions),
        the United States, Venezuela, and Yemen.
        <br />
        Any Spanish on this website is for LATAM only and is not designated for
        anyone in European Union or Spain For more information, please check out
        our FAQs.
        <br />
        Any Portuguese on this website is for Africa only, and is not designated
        for anyone in European Union or Portugal or Brazil. For more
        information, please check out our FAQs.
      </p>
      <p>
        <span class="page-footer-intro-blod">Compliance Disclosure：</span>The
        website can be accessed globally and is not specific to any entity. Your
        actual rights and obligations will be determined based on the entity and
        jurisdiction that you choose to be regulated.There may be local laws and
        regulations which prohibit or limit your rights to access, download,
        distribute, disseminate, share or otherwise use any or all of the
        documents and information published on this website.
      </p>
      <p>
        <span class="page-footer-intro-blod">Risk Warning: </span>Trading
        Contracts for Difference (CFDs) are complex financial instruments and
        come with a high risk of losing money rapidly due to leverage. Trade on
        margin carries a high level of risk and may not be suitable for all
        investors. Before deciding to trade Forex and CFDs, you should carefully
        consider your trading objectives, level of experience and risk appetite.
        The possibility exists that you could sustain a loss of some or all of
        your initial trading capital. We recommend that you seek independent
        advice and ensure you fully understand the risks involved before making
        any investment decision. Please read the relevant risk disclosure
        statements carefully before trading.
      </p>
  `,
};
